import { HTTP_TOKEN, HTTP_TOKEN_REPORT } from "./http";

export const getPixels = params => {
  return HTTP_TOKEN.get("populatepixel", { params }).then(result => {
    return result.data;
  });
};

export const getPixel = (pixelId) => {
  return HTTP_TOKEN.get(`populatepixel/${pixelId}`).then(result => {
    return result.data;
  });
};

export const createPixel = data => {
  return HTTP_TOKEN.post("populatepixel", data).then(result => {
    return result.data;
  });
};

export const updatePixel = (pixelId, data) => {
  return HTTP_TOKEN.put(`populatepixel/${pixelId}`, data).then(result => {
    return result.data;
  });
};

export const deletePixel = (pixelId) => {
  return HTTP_TOKEN.delete(`populatepixel/${pixelId}`).then(result => {
    return result.data;
  });
};


export const getLogEvents = params => {
  return HTTP_TOKEN_REPORT.get("pixel-send-marketing-log", { params }).then(result => {
    return result.data;
  });
};
